import { render, staticRenderFns } from "./user-crmaccess-card.vue?vue&type=template&id=277472ac&scoped=true&"
import script from "./user-crmaccess-card.vue?vue&type=script&lang=ts&"
export * from "./user-crmaccess-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277472ac",
  null
  
)

export default component.exports